// extracted by mini-css-extract-plugin
module.exports = {"toSettings":"PeergroupMenuPopup__toSettings__9VdTG"};